import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Footer from 'components/Footers/Footer';

const Configuration = () => {
    const navigate = useNavigate();


    return (
        <div
            style={{
                minHeight: "100vh",
                backgroundImage:
                    "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                backgroundSize: "cover",
                backgroundPosition: "center top",
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "400px",
                    background: 'rgba(0, 0, 0, 0.5)',
                }}
            >
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-2 text-white">Configuration</h1>
                            <p className="text-white mt-0 mb-5">
                                Here you can manage various configurations for the application.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid style={{ flex: 1 }}>
                <Row>
                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/school-setting`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Name and Setting</h4>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/opening-balance`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Opening Balance</h4>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/leave-types`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Leave Type</h4>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/leave-quota`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Leave Quota</h4>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/expense-category`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Income/Expense</h4>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/donation-category`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Donation Event</h4>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/salary-category`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Salary Management</h4>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/salary-att-policy`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Salary & Attendance Policy</h4>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/exam-type`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Exam Types</h4>
                            </CardBody>
                        </Card>
                    </Col>

                    <Col lg="6" xl="3" className="mb-4">
                        <Card
                            className="shadow clickable-card"
                            onClick={() => navigate(`/admin/grade-system`)}
                        >
                            <CardBody className="text-center">
                                <h4 className="mb-0">Grade System</h4>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </Container>
            <style>
                {`
                  .clickable-card {
                    cursor: pointer;
                    transition: transform 0.2s;
                  }
                  .clickable-card:hover {
                    transform: scale(1.05);
                  }
                `}
            </style>
            <Footer />
        </div>
    );
};

export default Configuration;
